import React from 'react';
import clsx from 'clsx';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
    tone?: 'neutral' | 'brand' | 'accent' | 'success' | 'danger' | 'warning' | 'info' | 'solidAccent' | 'solidBrand';
    dot?: boolean;
}

const tones: Record<NonNullable<BadgeProps['tone']>, string> = {
    neutral: 'bg-surface-sunken text-ink-secondary',
    brand: 'bg-brandsoft text-ink-brand',
    accent: 'bg-accentsoft text-ink-accent',
    success: 'bg-status-success-soft text-success-700',
    danger: 'bg-status-danger-soft text-danger-700',
    warning: 'bg-status-warning-soft text-warning-600',
    info: 'bg-status-info-soft text-info-600',
    solidAccent: 'bg-accent-500 text-ink-onAccent',
    solidBrand: 'bg-primary-500 text-white',
};

/** 22px status pill. */
export const Badge: React.FC<BadgeProps> = ({ tone = 'neutral', dot = false, className, children, ...props }) => (
    <span
        className={clsx('inline-flex items-center gap-[5px] whitespace-nowrap rounded-pill px-2.5 py-[5px] text-xs font-extrabold leading-none tracking-[.01em]', tones[tone], className)}
        {...props}
    >
        {dot && <span className="w-1.5 h-1.5 rounded-full bg-current" />}
        {children}
    </span>
);
export default Badge;
